<template>
  <div id="grade" class="grade" >
    <b-button v-for="goal in syllabuses[activeCourse.code].goals"
              v-bind:id="goal.id + evaluation.id"
              v-on:click="selectEvaluation(evaluation, goal, true)" v-b-tooltip.hover
              class="goal"
              :class="[{'grade-disabled': !isSelectedGoal(goal)}, getEvaluationGradeCriterion(evaluation, goal).style]" size="sm" variant="success">
      {{getEvaluationGradeCriterion(evaluation, goal).label}}
    </b-button>
    <b-tooltip :target="goal.id + evaluation.id" v-for='goal in syllabuses[activeCourse.code].goals' placement="top">
      <span v-html="getEvaluationCriterionText(evaluation, goal)"></span>
    </b-tooltip>
    <div v-for="goal in syllabuses[activeCourse.code].goals">
      <b-popover triggers="click" v-bind:target="goal.id + evaluation.id" v-if="!evaluation.lockedDate" ref="popover" title="Knowledge requirement">
        <div >
          <div style="margin-bottom: 10px"><span v-html="getEvaluationCriterionText(evaluation, goal)"></span></div>
          <small>Add evaluation</small>
          <b-container>
            <b-row v-for="criterion in filterCriterias(goal.criteria)" style="margin-top:20px">
              <b-col cols="2" align-self="center" style="margin-left:-10px;">
                <b-button v-on:click="setGradeToEvaluations(goal, criterion)" class="goal" :class="'grade-' + criterion.grade">{{criterion.label}}</b-button>
              </b-col>
              <b-col cols="10">
                <small><span v-html="criterion.text"></span></small>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-popover>
    </div>
  </div>
</template>
<script>

import api from '../api'

export default {
  name: 'Grade',
  props: ['evaluation', 'syllabuses', 'activeCourse', 'selectedEvaluations', 'activeCourseCode', 'evaluations', 'market'],
  data () {
    return {
      selectedEvaluationsMutable: this.selectedEvaluations
    }
  },
  watch: {
    selectedEvaluations: function (val) {
      this.selectedEvaluationsMutable = val
    }
  },
  methods: {
    filterCriterias: function (criterias) {
      var notEvaluatedGrade = {
        label: '',
        grade: '',
        text: 'Ej bedömd',
        criterionType: 'TEXT'
      }

      var filteredCriterias = []
      filteredCriterias.unshift(notEvaluatedGrade)
      for (var i in criterias) {
        if (criterias[i].label != '_') {
          filteredCriterias.push(criterias[i])
        }
      }
      return filteredCriterias
    },

    getEvaluationGradeCriterion: function (evaluation, goal) {
      if (!this.isSelectedGoal(goal)) {
        return {label: '', grade: '', text: '', criterionType: 'TEXT', style: 'grade-'}
      }
      var courseGoal = goal.goal ? goal.goal : goal
      for (var j in evaluation.grades) {
        if (evaluation.grades[j].criterion.goalId === courseGoal.id) {
          evaluation.grades[j].criterion.style = 'grade-' + evaluation.grades[j].criterion.grade
          return evaluation.grades[j].criterion
        }
      }
      return {label: '', grade: '', text: '', criterionType: 'TEXT', style: 'grade-'}
    },

    getEvaluationCriterionText: function (evaluation, goal) {
      var courseGoal = goal.goal ? goal.goal : goal
      if (this.market !== 'norway') {
        for (var i in evaluation.grades) {
          var gradesRole = evaluation.grades[i].role === null ? 'TEACHER' : evaluation.grades[i].role
          if (gradesRole === 'TEACHER') {
            if (evaluation.grades[i].criterion.goalId === courseGoal.id) {
              return evaluation.grades[i].criterion.text
            }
          }
        }
      }

      return courseGoal.text
    },

    isSelectedGoal: function (goal) {
      for (var j in this.activeCourse.goals) {
        if (goal.id === this.activeCourse.goals[j].goal.id) {
          return true
        }
      }
      return false
    },

    setGradeToEvaluations: function (goal, criterion) {
      this.$root.$emit('bv::hide::popover')
      for (var i in this.selectedEvaluationsMutable) {
        for (var j in this.evaluations[this.activeCourseCode]) {
          if (this.evaluations[this.activeCourseCode][j].id === this.selectedEvaluationsMutable[i]) {
            if (criterion && (criterion.label !== '' && criterion.grade !== '')) { // If criterion is present set, else remove grade
              this.addGrade(this.evaluations[this.activeCourseCode][j], criterion, goal)
            } else {
              this.removeGrade(this.evaluations[this.activeCourseCode][j], goal)
            }
          }
        }
      }
    },

    addGrade: function (evaluation, criterion, goal) {
      api.addGrade(goal, criterion, evaluation).then(response => {
        if (evaluation.grades) {
          var criterionReplaced = false
          for (var i in evaluation.grades) {
            if (evaluation.grades[i].role === 'TEACHER' || evaluation.grades[i].role === null) {
              if (evaluation.grades[i].criterion.goalId === criterion.goalId) {
                evaluation.grades[i].criterion = criterion
                criterionReplaced = true
                break
              }
            }
          }
          if (!criterionReplaced) {
            evaluation.grades.push({criterion: criterion, role: 'TEACHER'})
          }
        } else {
          evaluation.grades = []
          evaluation.grades.push({criterion: criterion, role: 'TEACHER'})
        }
      })

      if (this.selectedEvaluationsMutable.length === 1) {
        evaluation.selected = false
        this.selectedEvaluationsMutable.length = 0
        this.updateParentEvaluations()
      }
    },

    removeGrade: function (evaluation, goal) {
      api.removeGrade(evaluation, goal).then(response => {
        if (evaluation.grades) {
          for (var i in evaluation.grades) {
            if (evaluation.grades[i].role === 'TEACHER' || evaluation.grades[i].role === null) {
              if (evaluation.grades[i].criterion.goalId === goal.id) {
                evaluation.grades.splice(i, 1)
                break
              }
            }
          }
        }
      })
      if (this.selectedEvaluationsMutable.length === 1) {
        evaluation.selected = false
        this.selectedEvaluationsMutable.length = 0
        this.updateParentEvaluations()
      }
    },

    selectEvaluation: function (evaluation, goal, forceSelection) {
      if (goal) {
        if (this.activeGoalPopover !== evaluation.id + goal.id) {
          this.$root.$emit('bv::hide::popover')
        }
        this.activeGoalPopover = evaluation.id + goal.id
      }

      if (!evaluation.lockedDate) {
        this.selectedEvaluation = evaluation
        if (!forceSelection) {
          evaluation.selected = !evaluation.selected
        } else {
          evaluation.selected = true
        }
        this.addOrRemovedInListOfSelected(forceSelection, evaluation)
      }
    },

    addOrRemovedInListOfSelected (forceSelection, evaluation) {
      if (this.selectedEvaluationsMutable.includes(evaluation.id)) {
        if (!forceSelection) {
          this.selectedEvaluationsMutable.splice(this.selectedEvaluationsMutable.indexOf(evaluation.id), 1)
        }
      } else {
        this.selectedEvaluationsMutable.push(evaluation.id)
      }
      this.updateParentEvaluations()
    },

    updateParentEvaluations: function () {
      this.$emit('updateEvaluation', this.selectedEvaluationsMutable)
    }
  }
}
</script>

<style>
  .goal {
    height: 28px;
    width: 30px;
    font-weight: 400;
    border: 1px solid #ccc;
    margin: 2px !important;
    padding: 1px;
  }

  .grade:disabled {
    background-color: #CCC !important;
    opacity: 0.2;
  }

  .grade- {
    background-color: #FFFFFA !important;
  }

  .grade-A {
    background-color: rgb(39, 139, 172) !important;
  }

  .grade-C {
    background-color: rgba(39, 139, 172, 0.6) !important;
  }

  .grade-E {
    background-color: rgb(206,223,233) !important;
  }

  .grade-G {
    background-color: rgba(39, 139, 172, 0.2) !important;
  }

  .grade-- {
    background-color: #F16E6E !important;
  }

  .grade-_ {
    background-color: #FFFF66 !important;
  }

  .grade-I {
    background-color: rgb(178,216,174) !important;
  }

  .grade-II {
    background-color: #3AB129 !important;
  }

  .grade-X {
    background-color: #F16E6E !important;
  }

  .grade-disabled {
    outline: none;
    background-color: #CCC !important;
    opacity: 0.2;
    pointer-events:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Grade.vue